<!-- Dropdown menu container wiring a trigger slot to a positioned popover of items. -->

<script lang="ts" setup>
import {
  DropdownMenuArrow,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from 'reka-ui';
import type { PropType, VNodeChild } from 'vue';

import { DROPDOWN_CONTENT_CONFIG } from './DropdownContent.config';
import dropdownCss from './DropdownContent.module.scss';

type DropdownAlign = 'center' | 'end' | 'start';

defineProps({
  align: {
    type: String as PropType<DropdownAlign>,
    default: 'start',
  },
});

defineSlots<{
  default: () => VNodeChild;
  trigger: () => VNodeChild;
}>();
</script>

<template>
  <DropdownMenuRoot>
    <DropdownMenuTrigger as-child>
      <slot name="trigger" />
    </DropdownMenuTrigger>

    <DropdownMenuPortal>
      <DropdownMenuContent
        avoid-collisions
        portal
        :side="DROPDOWN_CONTENT_CONFIG.side"
        :side-offset="DROPDOWN_CONTENT_CONFIG.sideOffset"
        :collision-padding="DROPDOWN_CONTENT_CONFIG.collisionPadding"
        :align="align"
        :class="dropdownCss.dropdownContent"
      >
        <DropdownMenuArrow :class="dropdownCss.arrow" />
        <slot />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>
